// Storefront configuration returned by GET /api/configuration.
export interface AppConfiguration {
  /** Display name of the event currency, e.g. "Shopping Dollars". */
  rewardName: string;
}

// RCP-468 — per-SKU quantity limits returned by GET /api/configuration/cart-limit.
export interface CartLimitConfiguration {
  /** Maximum total quantity of one product in the cart (`CartLimits`). */
  maxQuantityPerProduct: number;
  /** Maximum total quantity of one SKU a customer may purchase per calendar month (`PurchaseLimits`). */
  maxQuantityPerSkuPerMonth: number;
}
